var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgGripVertical = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, className: "lucide lucide-grip-vertical-icon lucide-grip-vertical", viewBox: "0 0 24 24" }, props, { children: [_jsx("circle", { cx: 9, cy: 12, r: 1 }), _jsx("circle", { cx: 9, cy: 5, r: 1 }), _jsx("circle", { cx: 9, cy: 19, r: 1 }), _jsx("circle", { cx: 15, cy: 12, r: 1 }), _jsx("circle", { cx: 15, cy: 5, r: 1 }), _jsx("circle", { cx: 15, cy: 19, r: 1 })] }))); };
export default SvgGripVertical;
